module.exports = "<div #body class=\"sb-item-body\" [style.height]=\"height\">\n    <div class=\"card-body\">\n    \t<ng-content></ng-content>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/accordion/components/sb-item.body.html
// module id = ./src/app/typescripts/pro/accordion/components/sb-item.body.html
// module chunks = main